import React from "react";
import { formatDate } from "../utils";
const ListItem = ({ data, clicked, showCompanyColumn, index }) => {
  const recordsWithAudio = data.cdr?.filter((cdr) => cdr.billsec)?.length || 0;

  const getStatusColor = (status) => {
    const statusColors = {
      completed: "#28a745",
      pending: "#ffc107",
      active: "#007bff",
      cancelled: "#dc3545",
    };
    return statusColors[status?.toLowerCase()] || "#6c757d";
  };

  const rowStyle = {
    backgroundColor: index % 2 === 0 ? "#fff" : "#f8f9fa",
    transition: "all 0.2s ease",
  };

  return (
    <tr
      style={rowStyle}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#e3f2fd";
        e.currentTarget.style.transform = "scale(1.01)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = rowStyle.backgroundColor;
        e.currentTarget.style.transform = "scale(1)";
      }}
    >
      <td style={{ padding: "12px", fontWeight: "500" }}>{data.id}</td>
      <td style={{ padding: "12px" }}>{data.nume_proiect}</td>
      {showCompanyColumn && (
        <td style={{ padding: "12px" }}>
          {data.detalii?.firma || <em style={{ color: "#999" }}>necunoscut</em>}
        </td>
      )}
      <td style={{ padding: "12px", fontSize: "12px", color: "#666" }}>
        {formatDate(data.data_modificare)}
      </td>
      <td style={{ padding: "12px" }}>
        <span
          style={{
            padding: "4px 8px",
            borderRadius: "12px",
            backgroundColor: getStatusColor(data.status),
            color: "white",
            fontSize: "11px",
            fontWeight: "500",
          }}
        >
          {data.status}
        </span>
      </td>
      <td style={{ padding: "12px", fontFamily: "monospace" }}>
        {data.telefon}
      </td>
      <td style={{ padding: "12px" }}>
        <button
          onClick={() => clicked(data.id)}
          style={{
            padding: "8px 16px",
            backgroundColor: recordsWithAudio > 0 ? "#28a745" : "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: recordsWithAudio > 0 ? "pointer" : "default",
            fontSize: "12px",
            fontWeight: "500",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            if (recordsWithAudio > 0) {
              e.target.style.backgroundColor = "#218838";
              e.target.style.transform = "translateY(-1px)";
            }
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor =
              recordsWithAudio > 0 ? "#28a745" : "#6c757d";
            e.target.style.transform = "translateY(0)";
          }}
          disabled={recordsWithAudio === 0}
          title={`${recordsWithAudio} inregistrari cu audio`}
        >
          Vezi inregistrari ({recordsWithAudio})
        </button>
      </td>
    </tr>
  );
};

export default ListItem;
